"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportsModule = /** @class */ (function () {
    function ReportsModule() {
    }
    return ReportsModule;
}());
exports.ReportsModule = ReportsModule;
